// src/utils/auth.js
import { useSelector } from "react-redux";

export const isAuthenticated = () => {
	const token = useSelector((state) => state.auth.user.token);
	return !!token; // Return true if token exists
};
